import { Play } from "lucide-react";

export default function VideoPlayOverlay({ onPlay, playLabel, durationLabel }) {
  return (
    <button
      onClick={onPlay}
      className="absolute inset-0 w-full h-full flex flex-col items-center justify-center group bg-gradient-to-b from-black/10 to-black/55 transition"
      data-testid="showcase-play-btn"
      aria-label={playLabel}
    >
      <span className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-[var(--accent)] flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform">
        <Play
          className="w-9 h-9 sm:w-11 sm:h-11 text-white"
          fill="currentColor"
          style={{ marginLeft: "4px" }}
        />
      </span>
      <span className="mt-5 text-white font-bold text-base sm:text-lg drop-shadow">
        {playLabel}
      </span>
      <span className="mt-1 text-white/80 text-xs sm:text-sm drop-shadow">
        {durationLabel}
      </span>
    </button>
  );
}
